module.exports = "/static/assets/e2559f595c0c3b13891fe2567931dca7.png";